import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const startIsSymbol = {reflectSymbol: () => "start"};
const stopIsSymbol = {reflectSymbol: () => "stop"};
const daysIsSymbol = {reflectSymbol: () => "days"};
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode};
const TimeRange = x => x;
const OpeningHours = x => x;
const udecodeTimeRange = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(startIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(stopIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const udecodeOpeningHours = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(daysIsSymbol)({unsafeDecode: Unscramble.decodeArray(udecodeTimeRange.unsafeDecode)})(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
))();
const showTimeRange = {show: record => "{ start: " + Data$dShow.showIntImpl(record.start) + ", stop: " + Data$dShow.showIntImpl(record.stop) + " " + "}"};
const showOpeningHours = /* #__PURE__ */ (() => {
  const $0 = Data$dShow.showArrayImpl(showTimeRange.show);
  return {show: record => "{ days: " + $0(record.days) + " }"};
})();
const newtypeTimeRange = {Coercible0: () => {}};
const newtypeOpeningHours = {Coercible0: () => {}};
const eqTimeRange = {eq: ra => rb => ra.start === rb.start && ra.stop === rb.stop};
const eqOpeningHours = {
  eq: /* #__PURE__ */ (() => {
    const $0 = Data$dEq.eqArrayImpl(eqTimeRange.eq);
    return ra => rb => $0(ra.days)(rb.days);
  })()
};
const encodeTimeRange = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(stopIsSymbol)(encodeWithOptionsOther))(startIsSymbol)(encodeWithOptionsOther).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)
  }
))();
const encodeOpeningHours = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(daysIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(encodeTimeRange.encode);
      return {encodeWithOptions: v => encode1};
    })()).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)
  }
))();
const decodeTimeRange = /* #__PURE__ */ (() => (
  {
    decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(stopIsSymbol)(decodeWithOptionsOther)())(startIsSymbol)(decodeWithOptionsOther)()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
  }
))();
const decodeOpeningHours = /* #__PURE__ */ (() => (
  {
    decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(daysIsSymbol)((() => {
      const decode2 = Foreign$dGeneric$dClass.arrayDecode(decodeTimeRange).decode;
      return {decodeWithOptions: v => decode2};
    })())()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
  }
))();
export {
  OpeningHours,
  TimeRange,
  daysIsSymbol,
  decodeOpeningHours,
  decodeTimeRange,
  decodeWithOptionsOther,
  encodeOpeningHours,
  encodeTimeRange,
  encodeWithOptionsOther,
  eqOpeningHours,
  eqTimeRange,
  newtypeOpeningHours,
  newtypeTimeRange,
  showOpeningHours,
  showTimeRange,
  startIsSymbol,
  stopIsSymbol,
  udecodeOpeningHours,
  udecodeTimeRange
};
